import { __assign, __generator } from "tslib";
import { all, put, call, takeEvery } from 'redux-saga/effects';
import get from 'lodash/get';
import { Url, URLS, USER_PROFILE_POSTS_SUB_PATHS } from '@wix/da-url';
import ddt from '@wix/da-ddt';
import { getDeviationUrl } from '../../DeviationViews/_helpers';
import { convertToServerXhrPayload } from '../../DaEditorWrapper/utils';
import { request } from '../../xhr';
import { normalize } from '../../redux/normalizr';
import { putEntities } from '../../redux/entities/actions';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
import { editDeviationSuccess } from '../../redux/deviations/actionCreators';
import { logBiEvent } from '../../biLogger/redux/saga';
import { ResourceType } from '../../types/resource';
import { WriterPopupType } from './types';
import { publishWriterDeviation, saveWriterDeviation, saveWriterDeviationSuccess, saveWriterDeviationFailure, setIsRedirecting, } from './actions';
import { convertResponseErrorToWriterError, fakeResponse, getWriterEndpoint, } from './utils';
import { PureBiData } from '@wix/da-bi/pkg/events';
var logger = ddt.createLogger('writer.saga');
function dispatchSaveWriterDeviationFailure(response) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(saveWriterDeviationFailure(convertResponseErrorToWriterError(response === null || response === void 0 ? void 0 : response.errorDetails)))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function doCreateWriterDeviation(type, groupId, localState) {
    var _a, title, editorState, coverImage;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = localState.journalTitle, title = _a === void 0 ? '' : _a, editorState = localState.editorState, coverImage = localState.coverImage;
                logger.log('doCreateWriterDeviation', { type: type, groupId: groupId, localState: localState });
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: getWriterEndpoint('/create', type),
                        data: __assign({ title: title, group_id: groupId, cover_image_deviation_id: coverImage === null || coverImage === void 0 ? void 0 : coverImage.deviationId }, convertToServerXhrPayload(editorState === null || editorState === void 0 ? void 0 : editorState.rawContentState, editorState === null || editorState === void 0 ? void 0 : editorState.editorContent, editorState === null || editorState === void 0 ? void 0 : editorState.features)),
                    }, fakeResponse)];
            case 1: return [2 /*return*/, _b.sent()];
        }
    });
}
function doUpdateWriterDeviation(type, groupId, deviation, localState) {
    var _a, title, editorState, coverImage, result;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = localState.journalTitle, title = _a === void 0 ? '' : _a, editorState = localState.editorState, coverImage = localState.coverImage;
                logger.log('doUpdateWriterDeviation', {
                    type: type,
                    groupId: groupId,
                    deviation: deviation,
                    localState: localState,
                });
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: getWriterEndpoint('/update/content', type),
                        data: __assign({ title: title, group_id: groupId, deviationid: deviation === null || deviation === void 0 ? void 0 : deviation.deviationId, cover_image_deviation_id: coverImage === null || coverImage === void 0 ? void 0 : coverImage.deviationId }, convertToServerXhrPayload(editorState === null || editorState === void 0 ? void 0 : editorState.rawContentState, editorState === null || editorState === void 0 ? void 0 : editorState.editorContent, editorState === null || editorState === void 0 ? void 0 : editorState.features)),
                    }, fakeResponse)];
            case 1:
                result = _c.sent();
                if (!(result === null || result === void 0 ? void 0 : result.deviation)) {
                    logger.log('failure', result);
                    return [2 /*return*/, result];
                }
                if (type === WriterPopupType.LITERATURE) {
                    return [2 /*return*/, result];
                }
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: getWriterEndpoint('/update/metadata', type),
                        data: {
                            deviationid: deviation === null || deviation === void 0 ? void 0 : deviation.deviationId,
                            group_id: groupId,
                            featured: localState.isFeaturedPost,
                            // TODO: Uncomment this and replace it with the real mature param
                            // mature: localState.isMaturePost,
                            tiers: ((_b = localState.visibility) === null || _b === void 0 ? void 0 : _b.type) === 'tier'
                                ? localState.visibility.tiers.map(function (tier) { return tier.deviationId; })
                                : undefined,
                        },
                    }, fakeResponse)];
            case 2: return [2 /*return*/, _c.sent()];
        }
    });
}
/** Sends a request to our create or update endpoint depending on if the provided deviation exists */
function doCreateOrUpdateDeviation(type, groupId, deviation, localState) {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                result = null;
                if (!((deviation === null || deviation === void 0 ? void 0 : deviation.deviationId) === undefined)) return [3 /*break*/, 2];
                return [4 /*yield*/, call(doCreateWriterDeviation, type, groupId, localState)];
            case 1:
                result = _a.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, call(doUpdateWriterDeviation, type, groupId, deviation, localState)];
            case 3:
                result = _a.sent();
                _a.label = 4;
            case 4:
                if (!(result && (result === null || result === void 0 ? void 0 : result.deviation))) return [3 /*break*/, 6];
                return [4 /*yield*/, call(handleSuccess, { deviation: result === null || result === void 0 ? void 0 : result.deviation, type: type }, (deviation === null || deviation === void 0 ? void 0 : deviation.deviationId) !== undefined)];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, call(dispatchSaveWriterDeviationFailure, result)];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [2 /*return*/, result];
        }
    });
}
function handleSuccess(_a, wasEdit) {
    var _b, deviationId, entities, resultActions;
    var deviation = _a.deviation, type = _a.type;
    if (wasEdit === void 0) { wasEdit = false; }
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _b = normalize(deviation, deviationSchema), deviationId = _b.result, entities = _b.entities;
                resultActions = [
                    put(putEntities({ entities: entities })),
                    // Even though deviationId is expected to be a number and we're passing through the normalized
                    // deviation id (which could be number | string), it should only ever receive
                    // a deviation that production an id of type number
                    put(saveWriterDeviationSuccess({ deviationId: deviationId, type: type })),
                ];
                if (wasEdit) {
                    resultActions.push(put(editDeviationSuccess({ deviation: deviation })));
                }
                return [4 /*yield*/, all(resultActions)];
            case 1:
                _c.sent();
                logger.log('success', deviationId);
                return [2 /*return*/];
        }
    });
}
function handleRedirect(url) {
    return __generator(this, function (_a) {
        logger.log('redirect', url);
        window.location.assign(url);
        return [2 /*return*/];
    });
}
function handleSaveWriterDeviation(action) {
    var _a, type, deviation, groupId, localState, result, authorName, redirectTo;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: 
            // need to call "setIsRedirecting" before "doCommonSaveResultCleanup" to have a smooth
            // transition from isSubmitting to isRedirecting
            return [4 /*yield*/, put(setIsRedirecting({ isRedirecting: true }))];
            case 1:
                // need to call "setIsRedirecting" before "doCommonSaveResultCleanup" to have a smooth
                // transition from isSubmitting to isRedirecting
                _c.sent();
                _a = action.payload, type = _a.type, deviation = _a.deviation, groupId = _a.groupId, localState = _a.localState;
                return [4 /*yield*/, call(doCreateOrUpdateDeviation, type, groupId, deviation, localState)];
            case 2:
                result = _c.sent();
                if (!(result === null || result === void 0 ? void 0 : result.deviation)) return [3 /*break*/, 4];
                authorName = ((_b = result.deviation.author) === null || _b === void 0 ? void 0 : _b.username) || '';
                redirectTo = result.deviation.isPublished
                    ? getDeviationUrl(result.deviation)
                    : Url.userPostsLink({
                        username: authorName,
                        subPath: USER_PROFILE_POSTS_SUB_PATHS.DRAFTS,
                    });
                if (type === WriterPopupType.LITERATURE) {
                    // Saving a Literature draft should redirect to the sta.sh draft folder
                    // but since we do not know the drafts folder hash (yet to be implemented
                    // on the backend) we should redirect to the sta.sh root
                    redirectTo = Url.buildFromPath(URLS.STASH);
                    // If its published we need to redirect back to submit not stash
                    if (deviation === null || deviation === void 0 ? void 0 : deviation.isPublished) {
                        redirectTo = "".concat(Url.buildFromPath(URLS.SUBMIT), "?deviationids=").concat(deviation.deviationId);
                    }
                }
                return [4 /*yield*/, call(handleRedirect, redirectTo)];
            case 3:
                _c.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, put(setIsRedirecting({ isRedirecting: false }))];
            case 5:
                _c.sent();
                _c.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
function handlePublishWriterDeviation(action) {
    var _a, type, groupId, refreshAfterSubmit, deviation, localState, saveResult, deviationid, result, returnedDeviation;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = action.payload, type = _a.type, groupId = _a.groupId, refreshAfterSubmit = _a.refreshAfterSubmit, deviation = _a.deviation, localState = _a.localState;
                logger.log('publishWriterDeviation', action.payload);
                // need to call "setIsRedirecting" before any save/publish requests to have a smooth
                // transition from isSubmitting to isRedirecting
                return [4 /*yield*/, put(setIsRedirecting({ isRedirecting: true }))];
            case 1:
                // need to call "setIsRedirecting" before any save/publish requests to have a smooth
                // transition from isSubmitting to isRedirecting
                _c.sent();
                return [4 /*yield*/, call(doCreateOrUpdateDeviation, type, groupId, deviation, localState)];
            case 2:
                saveResult = _c.sent();
                if (!(!saveResult || !saveResult.deviation)) return [3 /*break*/, 4];
                if (saveResult && saveResult.errorCode === 302) {
                    window.location.replace(saveResult.errorDetails.redirectUrl);
                }
                return [4 /*yield*/, call(dispatchSaveWriterDeviationFailure, saveResult)];
            case 3:
                _c.sent();
                return [2 /*return*/];
            case 4:
                deviationid = get(saveResult.deviation, 'deviationId', null);
                if (!(type === WriterPopupType.LITERATURE)) return [3 /*break*/, 8];
                if (!!(deviation === null || deviation === void 0 ? void 0 : deviation.isPublished)) return [3 /*break*/, 6];
                return [4 /*yield*/, call(logBiEvent, PureBiData({
                        evid: 11,
                        group_exclusive: groupId !== undefined,
                        typeid: ResourceType.DEVIATION,
                        itemid: deviationid,
                    }))];
            case 5:
                _c.sent();
                _c.label = 6;
            case 6: return [4 /*yield*/, call(handleRedirect, "".concat(Url.buildFromPath(URLS.SUBMIT), "?deviationids=").concat(deviationid))];
            case 7:
                _c.sent();
                return [2 /*return*/];
            case 8: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: getWriterEndpoint('/publish', type),
                    data: {
                        deviationid: deviationid,
                        featured: localState.isFeaturedPost,
                        // TODO: Uncomment this and replace it with the real mature param
                        // mature: localState.isMaturePost,
                        group_id: groupId,
                        tiers: ((_b = localState.visibility) === null || _b === void 0 ? void 0 : _b.type) === 'tier'
                            ? localState.visibility.tiers.map(function (tier) { return tier.deviationId; })
                            : undefined,
                    },
                }, fakeResponse)];
            case 9:
                result = _c.sent();
                logger.log('response', result);
                if (!(result && result.deviation)) return [3 /*break*/, 15];
                returnedDeviation = result.deviation;
                return [4 /*yield*/, call(logBiEvent, PureBiData({
                        evid: 11,
                        group_exclusive: groupId !== undefined,
                        typeid: ResourceType.JOURNAL,
                        itemid: returnedDeviation.deviationId,
                    }))];
            case 10:
                _c.sent();
                return [4 /*yield*/, call(handleSuccess, { deviation: returnedDeviation, type: type })];
            case 11:
                _c.sent();
                if (!refreshAfterSubmit) return [3 /*break*/, 12];
                window.location.reload();
                return [3 /*break*/, 14];
            case 12: return [4 /*yield*/, call(handleRedirect, getDeviationUrl(returnedDeviation))];
            case 13:
                _c.sent();
                _c.label = 14;
            case 14: return [3 /*break*/, 18];
            case 15: return [4 /*yield*/, put(setIsRedirecting({ isRedirecting: false }))];
            case 16:
                _c.sent();
                return [4 /*yield*/, call(dispatchSaveWriterDeviationFailure, result)];
            case 17:
                _c.sent();
                _c.label = 18;
            case 18: return [2 /*return*/];
        }
    });
}
function handleSaveWriterDeviationFailure(action) {
    return __generator(this, function (_a) {
        logger.log('failure', action.payload.error);
        return [2 /*return*/];
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(saveWriterDeviation, handleSaveWriterDeviation),
                    takeEvery(publishWriterDeviation, handlePublishWriterDeviation),
                    takeEvery(saveWriterDeviationFailure, handleSaveWriterDeviationFailure),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map